import * as Reducer from './slice';

interface IAppState {
  // this feature state
  [Reducer.statePropName]: Reducer.ICheckoutState;
}

const getCheckoutState = (state: IAppState) => state[Reducer.statePropName];

export const isCheckoutReady = (state: IAppState) => getCheckoutState(state).ready;

export const isCheckoutLoading = (state: IAppState) => getCheckoutState(state).loading;

export const getHostedPageData = (state: IAppState) => getCheckoutState(state).hostedPage;

export const isFreshPremium = (state: IAppState) => getCheckoutState(state).isFreshPremium;
